const hashString = require('hash-string'); // 针对每一个英文单词做相关运算，每次运算会得到一个新的hash值
const { lngs, routerLngs } = require('./constant'); // 获取当前系统的语种数对象和对应路由参数信息

const hashKey = (value) => `k_${`0000${hashString(value.replace(/\s+/g, '')).toString(36)}`.slice(-7)}`;

const env = ['prod', 'pre'].includes(process.env.ZONE_ENV) ? 'prod' : 'dev';

let entities = {};
const Languages = {};

Object.values(lngs).forEach((item) => {
  Languages[item.toUpperCase()] = item;
  entities = {
    ...entities,
    ...{
      [item]: {
        id: item,
        ...routerLngs[item],
      },
    },
  };
});

const LanguageCollection = {
  list: Object.values(lngs),
  entities,
};

/**
 * 从 url 上解析出语言属性，其中返回的 path 不带语言属性
 */
const extractUrl = (srcUrl) => {
  let protocal;
  let host;
  let path;
  let language = 'en'; // 默认为英文

  if (/^((?:https?:)?\/\/)([^/]+)(\/.*)?$/.test(srcUrl)) {
    protocal = RegExp.$1;
    host = RegExp.$2;
    path = RegExp.$3;
  } else {
    protocal = '';
    host = '';
    path = srcUrl;
  }
  const [tempPath, anchor] = path.split('#');
  path = tempPath;
  const pathname = path.split('?')[0];
  const base = pathname.slice(1).split('/')
    .shift() || '';
  const match = LanguageCollection.entities[base];

  if (match) {
    language = match.id;
    path = path.replace(new RegExp(`^/${language}`), '');
  }

  return {
    protocal,
    host,
    path,
    language,
    anchor,
  };
};

module.exports = {
  Languages,
  hashKey,
  extractUrl,
  LanguageCollection,
  env,
};
